import React, {useEffect, useRef, useState} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment";
import __ from "lodash";
import DataGrid from "../../../controls/DataGrid";

import { useShipmentTracking } from "../../../services/shipmentTracking";

const eventTypes = [
  {code: "FWB",  value: "Electronic Waybill"},
  {code: "BKD",  value: "BKD - Booked"},
  {code: "FOH",  value: "FOH - Received From Shipper"},
  {code: "RCS",  value: "RCS - Ready For Carriage"},
  {code: "RCT",  value: "RCT - Received From Other Airline"},
  {code: "PRE",  value: "PRE - Prepared"},
  {code: "MAN",  value: "MAN - Manifested"},
  {code: "FOW",  value: "FOW - Delivered to Ramp"},
  {code: "DEP",  value: "DEP - Departed"},
  {code: "ARR",  value: "ARR - Shipment Arrived"},
  {code: "AWR",  value: "AWR - Documents Arrived"},
  {code: "FIW",  value: "FIW - Received into Warehouse"},
  {code: "RCF",  value: "RCF - Received From Flight"},
  {code: "NFD",  value: "NFD - Agent Notified"},
  {code: "AWD",  value: "AWD - Documents Delivered"},
  {code: "DLV",  value: "DLV - Delivered"},
  {code: "OCI",  value: "OCI - Customs,Security,Regulatory Information"},
  {code: "FFM",  value: "FFM - Flight Manifest"},
  {code: "CPM",  value: "CPM - Flight Loading"},
  {code: "TAKEOFF",  value: "TAKEOFF - Flight Take-off"},
  {code: "LANDING",  value: "LANDING - Flight Landing"},
];

const ShipmentTrackingActivityGrid = (_props) => {
  const {isAuthenticated} = useAuth0();
  const props = {
    ..._props
  }
  const SystemData = props.systemData;
  const eventBus = SystemData.eventBus;

  const [state, setState] = useState({
    canEdit: props.canEdit||false,
    extraKeys: [],
  });


  const dataGridRef = useRef();

  const queryClient = useQueryClient();
  const shipmentActivity = useShipmentTracking({queryClient, extraKeys: state.extraKeys});

  useEffect(()=> {
    const search = async (params) => {
      const {awbPrefix, awbSerial} = params;
        if (awbPrefix && awbSerial) {
          setState ({...state,  extraKeys: [`${awbPrefix}-${awbSerial}`]});
        }
    }
    const clearSearch = async (params) => {
      setState ({...state,  extraKeys: ['999-9999999']});
    }

    eventBus.bind("AwbTracking.search", search);
    eventBus.bind("AwbTracking.clearSearch", clearSearch);
    return () => {
      eventBus.unbind("AwbTracking.search", search);
      eventBus.unbind("AwbTracking.clearSearch", clearSearch);
    }
  }, [eventBus, queryClient]);


  const getColumns = (props) => {
    const baseColumn = {
      options: {
        cellStyle: { fontSize:14, textAlign: "left" },
      },
      editable: props.canEdit,
    };

    return [
      {
        ...baseColumn,
        headerName: "Time",
        field: "eventTime",
        // width: 160,
        valueFormatter: (params)=> {
          return params.value ? moment.utc(params.value).format("DD/MM/YYYY HH:mm") : "";
        }
      },
      {
        ...baseColumn,
        headerName: "Status",
        field: "eventType",
        // minWidth: 200,
        type:'text',
        flex: 1,
        valueFormatter: (params)=> {
          const event = __.find(eventTypes, {code: params.value});
          const valueToRender = (event === undefined) ? "" : event.value;
          return(`${valueToRender}`);
        }
      },
      {
        ...baseColumn,
        headerName: "Station",
        field: "eventAirportCode",
        // width: 100,
      },
      {
        ...baseColumn,
        headerName: "Details",
        field: "details",
        // minWidth: 250,
        flex: 2,
        valueFormatter: (params)=> {
          // console.log(params)
          // const end = moment(params.data.endCheckDate);
          // const start = moment(params.data.startCheckDate);
          // const duration = moment.duration(end.diff(start, 'hours', true), 'hours');
          // const displayDuration = duration._data ? `${duration._data.days ? `${duration._data.days} days, ` : ``}${duration._data.hours} hours` : ``;
          const displayDetails = params.data?.details;
          return (`${displayDetails || ""}`);
        }
      },
    ];
  };

  return (isAuthenticated &&
    <div style={{width: props.width?props.width:"100%", ...props.style, backgroundColor: "rgb(238, 238, 238)"}}>
      <DataGrid
        title="ShipmentTrackingActivity"
        ref={dataGridRef}
        columns={getColumns({canEdit: state.canEdit})}
        rows={shipmentActivity.data}
        height={props.height||`calc(100vh - ${(290)}px)`}
        options={{
          singleClickEdit: true,
          // editType:'fullRow',
          onCellValueChanged: ()=>{}, //prevent default onCellValueChanged
          defaultColDef: {
            editable: false,
            resizable: false,
          }
        }}
      />
    </div>
  );

}

export default ShipmentTrackingActivityGrid;
